import {
  Card,
  CardContent,
  Typography,
  Grid2 as Grid,
  Box,
  Avatar,
  IconButton,
  Tooltip,
  Button,
} from "@mui/material";
import { alpha } from "@mui/system";
import { useNavigate } from "react-router-dom";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import RoofingIcon from "@mui/icons-material/Roofing";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import PoolIcon from "@mui/icons-material/Pool";
import PlumbingIcon from "@mui/icons-material/Plumbing";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import ConstructionIcon from "@mui/icons-material/Construction";
import HouseIcon from "@mui/icons-material/House";
import BuildIcon from "@mui/icons-material/Build";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import SettingsIcon from "@mui/icons-material/Settings";
import EngineeringIcon from "@mui/icons-material/Engineering";
import GavelIcon from "@mui/icons-material/Gavel";
import EditIcon from "@mui/icons-material/Edit";

import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const ContractorCard = ({
  data,
  mb,
  colorIndex,
  empty,
  showLicenseInput,
  deleteLicenses,
  currLicense,
  contractorSite,
  handleEditContractor,
  addNewActive,
  currentContractor,
  hideEditActions,
  fromQuickActions,
  handleNavigate,
  maxPage,
  cardPage,
}) => {
  const navigate = useNavigate();

  const getInitials = (fullName) => {
    if (fullName) {
      const nameParts = fullName.split(" ");
      const initials =
        nameParts.length > 1
          ? nameParts[0][0] + nameParts[1][0]
          : nameParts[0][0];

      if (initials) {
        return initials.toUpperCase();
      } else {
        return "N/A";
      }
    } else {
      return "N/A";
    }
  };

  const getRankIcon = (rank) => {
    switch (rank) {
      case "Cert Roofing":
        return <RoofingIcon />;
      case "Cert Specialty":
      case "Reg Specialty":
        return <HomeRepairServiceIcon />;
      case "Cert Pool":
      case "Reg Pool":
        return <PoolIcon />;
      case "Cert Plumbing":
      case "Reg Plumbing":
        return <PlumbingIcon />;
      case "Cert Solar":
        return <WbSunnyIcon />;
      case "Cert Building":
      case "Reg Building":
        return <ConstructionIcon />;
      case "Cert Residential":
      case "Reg Residential":
        return <HouseIcon />;
      case "Cert General":
      case "Reg General":
        return <BuildIcon />;
      case "Cert Under":
      case "Reg Under":
        return <VerifiedUserIcon />;
      case "Cert Pollutant":
        return <SettingsIcon />;
      case "Cert Mechanical":
      case "Reg Mech":
        return <EngineeringIcon />;
      case "Reg Tank Tester":
        return <GavelIcon />;
      case "Reg Air":
      case "Cert Air":
        return <WbSunnyIcon />;
      case "Reg Sheet Metal":
      case "Cert Metal":
        return <BuildIcon />;
      default:
        return <ConstructionIcon />;
    }
  };

  const colors = [
    "#3f51b5", // Indigo
    "#f44336", // Red
    "#4caf50", // Green
    "#ff9800", // Orange
    "#9c27b0", // Purple
    "#673ab7", // Deep Purple
    "#009688", // Teal
    "#795548", // Brown
    "#1e88e5", // Blue
    "#d32f2f", // Dark Red
    "#3f51b5", // Indigo
    "#f44336", // Red
    "#4caf50", // Green
    "#ff9800", // Orange
    "#9c27b0", // Purple
    "#673ab7", // Deep Purple
    "#009688", // Teal
    "#795548", // Brown
    "#1e88e5", // Blue
    "#d32f2f", // Dark Red
  ];

  const getRandomColor = () => {
    if (colorIndex) {
      return colors[colorIndex];
    } else {
      return colors[0];
    }
  };

  const avatarColor = getRandomColor();

  return (
    <Card
      sx={{
        maxWidth: 400,
        margin: "auto",
        mb: mb || undefined,
        boxShadow: 6,
        borderRadius: 3,
        border: "3px solid",
        borderColor:
          currLicense && deleteLicenses?.includes(currLicense)
            ? "red"
            : alpha("#000000", 0.1),
        backgroundColor:
          currLicense && deleteLicenses?.includes(currLicense)
            ? alpha("#FF0000", 0.1)
            : undefined,
        position: "relative",
      }}
    >
      <CardContent sx={{ position: "relative" }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }} sx={{ textAlign: "center" }}>
            <Avatar
              sx={{
                bgcolor: avatarColor,
                width: 80,
                height: 80,
                margin: "auto",
                mb: 2,
              }}
            >
              <Typography sx={{ cursor: "default" }} variant="h5">
                {!data
                  ? // ? "No contractors have been added yet"
                    "N/A"
                  : `${getInitials(data?.firstName + " " + data?.lastName)}`}
              </Typography>
            </Avatar>
            {empty ? (
              <Box
                className={showLicenseInput && "fadeInPlaceHolder1"}
                sx={{
                  mb: 1,
                  mx: "auto",
                  height: "1.5rem",
                  width: "14rem",
                  backgroundColor: "#f3f3f3",
                  borderRadius: "20px",
                }}
              ></Box>
            ) : data?.middleName ? (
              <Typography
                sx={{ cursor: "default" }}
                variant="h5"
                component="div"
              >
                {data?.firstName +
                  " " +
                  data?.middleName +
                  " " +
                  data?.lastName}
              </Typography>
            ) : (
              <Typography
                sx={{ cursor: "default", pt: !data ? 2 : undefined }}
                variant="h5"
                component="div"
              >
                {!data
                  ? "No contractors have been added yet"
                  : `${data?.firstName + " " + data?.lastName}`}
              </Typography>
            )}
            {empty ? (
              <Box
                className={showLicenseInput && "fadeInPlaceHolder2"}
                sx={{
                  mx: "auto",
                  mb: 1,
                  height: "1.5rem",
                  width: "14rem",
                  backgroundColor: "#f3f3f3",
                  borderRadius: "20px",
                }}
              ></Box>
            ) : (
              <Typography
                sx={{ cursor: "default" }}
                variant="body1"
                fontWeight="bold"
                color="textSecondary"
              >
                {data?.businessName}
              </Typography>
            )}
            {empty ? (
              <Box
                className={showLicenseInput && "fadeInPlaceHolder3"}
                sx={{
                  mx: "auto",
                  mb: 1,
                  height: "1.5rem",
                  width: "10rem",
                  backgroundColor: "#f3f3f3",
                  borderRadius: "20px",
                }}
              ></Box>
            ) : (
              <Typography
                sx={{ cursor: "default", mt: 1 }}
                variant="body1"
                fontWeight="bold"
                color="textSecondary"
              >
                {data?.licenseType}
              </Typography>
            )}
            {empty ? (
              <Box
                className={showLicenseInput && "fadeInPlaceHolder4"}
                sx={{
                  mx: "auto",
                  height: "1.5rem",
                  width: "10rem",
                  backgroundColor: "#f3f3f3",
                  borderRadius: "20px",
                }}
              ></Box>
            ) : (
              <Typography
                sx={{ cursor: "default", mt: 0 }}
                variant="h6"
                color="textSecondary"
              >
                {data?.licenseNumber}
              </Typography>
            )}
            {data?.status && (
              <Box
                sx={{
                  position: "absolute",
                  top: 16,
                  left: 16,
                  borderRadius: 1,
                  padding: "0.5rem",
                }}
              >
                {/* <RoofingIcon sx={{ mr: 1 }} /> */}
                <Typography
                  sx={{ cursor: "default" }}
                  variant="h6"
                  color={
                    (currLicense && deleteLicenses?.includes(currLicense)) ||
                    data?.status === "Inactive"
                      ? "red"
                      : "#4caf50"
                  }
                >
                  {currLicense && deleteLicenses?.includes(currLicense)
                    ? "Removed"
                    : data?.status}
                </Typography>
                <Typography
                  sx={{ cursor: "default" }}
                  variant="body1"
                  fontWeight="bold"
                  color="primary"
                >
                  {data?.expires}
                </Typography>
              </Box>
            )}
            {data?.rank && (
              <Box
                sx={{
                  position: "absolute",
                  top: 16,
                  right: 16,
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: alpha("#000000", 0.1),
                  borderRadius: 1,
                  padding: "0.5rem",
                }}
              >
                {getRankIcon(data?.rank)}
                {/* <RoofingIcon sx={{ mr: 1 }} /> */}
                <Typography
                  sx={{ cursor: "default" }}
                  variant="body2"
                  color="textSecondary"
                >
                  {data?.rank}
                </Typography>
              </Box>
            )}
          </Grid>
          <Grid size={{ xs: 12 }} sx={{ textAlign: "left", mt: 2 }}>
            <Box
              className={showLicenseInput && "fadeInPlaceHolder5"}
              sx={{ display: "flex", alignItems: "center" }}
            >
              {data && (
                <LocationOnIcon
                  sx={{ mr: 1, color: empty ? "#d3d3d3" : undefined }}
                />
              )}

              {empty ? (
                <Box
                  className={showLicenseInput && "fadeInPlaceHolder5"}
                  sx={{
                    mb: 1,
                    height: "1.5rem",
                    width: "100%",
                    backgroundColor: "#f3f3f3",
                    borderRadius: "20px",
                  }}
                ></Box>
              ) : (
                <Typography
                  sx={{ cursor: "default" }}
                  variant="body2"
                  color="textSecondary"
                >
                  {data?.mainAddress}
                </Typography>
              )}
            </Box>
            <Box
              className={showLicenseInput && "fadeInPlaceHolder6"}
              sx={{ display: "flex", alignItems: "center", mb: 1 }}
            >
              <LocationOnIcon sx={{ mr: 1, visibility: "hidden" }} />
              {empty ? (
                <Box
                  className={showLicenseInput && "fadeInPlaceHolder6"}
                  sx={{
                    height: "1.5rem",
                    width: "30%",
                    backgroundColor: "#f3f3f3",
                    borderRadius: "20px",
                  }}
                ></Box>
              ) : (
                <Typography
                  sx={{ cursor: "default" }}
                  variant="body2"
                  color="textSecondary"
                >
                  {data?.mainAddressCounty}
                </Typography>
              )}
            </Box>
            <Box
              className={showLicenseInput && "fadeInPlaceHolder7"}
              sx={{ display: "flex", alignItems: "center", mb: 1 }}
            >
              {data && (
                <EmailIcon
                  sx={{ mr: 1, color: empty ? "#d3d3d3" : undefined }}
                />
              )}

              {empty ? (
                <Box
                  className={showLicenseInput && "fadeInPlaceHolder7"}
                  sx={{
                    height: "1.5rem",
                    width: "100%",
                    backgroundColor: "#f3f3f3",
                    borderRadius: "20px",
                  }}
                ></Box>
              ) : (
                <Typography
                  sx={{ cursor: "default" }}
                  variant="body2"
                  color="textSecondary"
                >
                  {data?.email}
                </Typography>
              )}
            </Box>
            <Box
              className={showLicenseInput && "fadeInPlaceHolder8"}
              sx={{ display: "flex", alignItems: "center", mb: 1 }}
            >
              {data && (
                <PhoneIcon
                  sx={{ mr: 1, color: empty ? "#d3d3d3" : undefined }}
                />
              )}

              {empty ? (
                <Box
                  className={showLicenseInput && "fadeInPlaceHolder8"}
                  sx={{
                    mb: 1,
                    height: "1.5rem",
                    width: "100%",
                    backgroundColor: "#f3f3f3",
                    borderRadius: "20px",
                  }}
                ></Box>
              ) : (
                <Typography
                  sx={{ cursor: "default" }}
                  variant="body2"
                  color="textSecondary"
                >
                  {data?.mobile}
                </Typography>
              )}
            </Box>

            {/* Add Contractor Button for empty state in quick actions */}
            {empty && fromQuickActions && (
              <Box
                sx={{
                  position: "absolute",
                  bottom: 20,
                  left: 0,
                  right: 0,
                  display: "flex",
                  justifyContent: "center",
                  mt: 3,
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<EngineeringIcon />}
                  onClick={() => navigate("/contractors")}
                  sx={{
                    borderRadius: 2,
                    textTransform: "none",
                    px: 3,
                    py: 1.5,
                  }}
                >
                  Add Contractor
                </Button>
              </Box>
            )}
          </Grid>
        </Grid>
        {contractorSite &&
          !hideEditActions &&
          !addNewActive &&
          !fromQuickActions &&
          currentContractor &&
          Object.keys(currentContractor).length > 0 && (
            <Box sx={{ position: "absolute", right: 10, bottom: 10 }}>
              <Tooltip title="Edit Contractor" arrow>
                <IconButton
                  onClick={handleEditContractor}
                  color="primary"
                  sx={{
                    backgroundColor: (theme) =>
                      theme.palette.primary.main + "10", // Adds transparency for a lighter effect
                    "&:hover": {
                      backgroundColor: (theme) =>
                        theme.palette.primary.main + "20", // Slightly darker on hover
                    },
                  }}
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
            </Box>
          )}

        {fromQuickActions && data && (
          <Box
            sx={{
              position: "absolute",
              left: 0,
              right: 0,
              bottom: 0,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              pb: 1, // add padding if you want space from the card edge
            }}
          >
            <IconButton
              sx={{
                visibility:
                  cardPage === 1 || Boolean(addNewActive)
                    ? "hidden"
                    : "visible",
              }}
              onClick={() => handleNavigate("back")}
            >
              <ArrowBackIosNewIcon sx={{ fontSize: "20px" }} />
            </IconButton>
            <Typography align="center" variant="h5">
              {maxPage === 0 ? "0/0" : cardPage + "/" + maxPage}
            </Typography>
            <IconButton
              onClick={() => handleNavigate("forward")}
              sx={{
                visibility:
                  maxPage === 0 || cardPage === maxPage ? "hidden" : "visible",
              }}
            >
              <ArrowForwardIosIcon sx={{ fontSize: "20px" }} />
            </IconButton>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default ContractorCard;
